function getPriceBreakdown(offerPlan) {
  const { contentMap, priceDetails, priceTotal } = offerPlan;
  const priceBreakdownItems = priceDetails?.map(item => {
    const label = item.label;
    const price2 = item.price;
    const price =
      !!item?.original && item.original !== item.price ? item.original : " ";
    const strikethrough = !!item?.original;
    return {
      label,
      price,
      price2,
      strikethrough
    };
  });

  return {
    headline: " ",
    savingsLabel: "",
    items: priceBreakdownItems,
    totalLabel: contentMap.get("TOTAL_LABEL"),
    totalLabel2: contentMap.get("TOTAL_SUBLABEL"),
    totalPrice:
      !!priceTotal?.original && priceTotal.original !== priceTotal.price
        ? priceTotal.original
        : " ",
    totalPrice2: priceTotal?.price,
    totalStrikethrough: !!priceTotal?.original,
    marketingMessage: contentMap.get("STARTER_FEE_SUBLABEL") || "",
    version: "V5"
  };
}

export default getPriceBreakdown;
